import {
  Facebook,
  Instagram,
  Qrcode,
  Whatsapp,
} from '@unified-checkout/design-system/icons/index';
import { IButton } from 'libs/design-system/src/types/Button/button';

export const INPUT_STATUS = {
  DEFAULT: 'default',
  ERROR: 'error',
  WARNING: 'warning',
} as const;

export const EGY_PREFIXES = ['10', '11', '12', '15'];

export const EMPTY_DEFAULT_TAGS = [];

export const COUNTRY_NAMES: Record<string, { en: string; ar: string }> = {
  EGY: { en: 'Egypt', ar: 'مصر' },
  ARE: { en: 'UAE', ar: 'الإمارات' },
  SAU: { en: 'Saudi Arabia', ar: 'السعودية' },
  OMN: { en: 'Oman', ar: 'عُمان' },
  JOR: { en: 'Jordan', ar: 'الأردن' },
  PAK: { en: 'Pakistan', ar: 'باكستان' },
  KWT: { en: 'Kuwait', ar: 'الكويت' },
};

export const DEFAULT_LOCALIZATION = {
  en: {
    title: 'Your payment link is live!',
    subTitle: 'The link has been shared with your customers.',
    shareLabel: 'Share Link',
    tagsLabel: 'Share via email or phone number',
    tagsPlaceholder: 'Email or phone number, comma separated',
    tagsHintText: (countryName: string) =>
      `SMS can only be sent to numbers in ${countryName}`,
    tagsShareBtn: 'Share',
    duplicateData: 'This information has already been entered',
    sent: 'sent',
  },
  ar: {
    title: 'رابط الدفع الخاص بك مباشر الآن!',
    subTitle: 'تم مشاركة الرابط مع عملائك.',
    shareLabel: 'مشاركة الرابط',
    tagsLabel: 'مشاركة عبر البريد الإلكتروني أو رقم الهاتف',
    tagsPlaceholder: 'البريد الإلكتروني أو رقم الهاتف، مفصولين بفاصلة',
    tagsHintText: (countryName: string) =>
      `يمكن إرسال الرسائل القصيرة فقط إلى الأرقام في ${countryName}`,
    tagsShareBtn: 'شارك',
    duplicateData: 'تم إدخال هذه المعلومات بالفعل',
    sent: 'تم الإرسال',
  },
};

export const SOCIAL_MEDIA = {
  QR_CODE: 'qr-code',
  WHATSAPP: 'whatsapp',
  INSTAGRAM: 'instagram',
  FACEBOOK: 'facebook',
};

const SOCIAL_BTNS_INITIAL_VALUES: Pick<IButton, 'variant' | 'color' | 'size'> =
  {
    variant: 'outlined',
    color: 'secondary',
    size: 'md',
  };

export const SOCIAL_SHARE_URLS: Record<string, (link: string) => string> = {
  [SOCIAL_MEDIA.WHATSAPP]: (link) =>
    `https://wa.me/?text=${encodeURIComponent(link)}`,
  [SOCIAL_MEDIA.FACEBOOK]: (link) =>
    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`,
};

export const SPECIAL_SOCIAL_SHARE_HANDLERS: Record<string, () => void> = {
  [SOCIAL_MEDIA.INSTAGRAM]: () => {
    window.open('https://www.instagram.com', '_blank');
  },
};

export const DEFAULT_SOCIAL_MEDIA_BTNS: IButton[] = [
  {
    ...SOCIAL_BTNS_INITIAL_VALUES,
    id: SOCIAL_MEDIA.QR_CODE,
    leadingIcon: Qrcode,
  },
  {
    ...SOCIAL_BTNS_INITIAL_VALUES,
    id: SOCIAL_MEDIA.WHATSAPP,
    leadingIcon: Whatsapp,
  },
  {
    ...SOCIAL_BTNS_INITIAL_VALUES,
    id: SOCIAL_MEDIA.INSTAGRAM,
    leadingIcon: Instagram,
  },
  {
    ...SOCIAL_BTNS_INITIAL_VALUES,
    id: SOCIAL_MEDIA.FACEBOOK,
    leadingIcon: Facebook,
  },
];
